import axios, { mockData } from '@/utils/axios'

// 获取3s克隆sku信息
export const get3sClonePayInfoByKey = ({ key }) => {
  return axios.get(`/apis/moyin-account/v1/trc/market/order/sms/info?key=${key}`)
}

// 获取3s克隆sku信息
export const create3sCloneOrder = (data) => {
  return axios.post(`/apis/moyin-account/v1/trc/market/order`, data)
}

// 获取3s克隆支付结果
export const get3sPayResult = (params) => {
  return axios.get(`/apis/moyin-account/v1/trc/market/order/staus`, {
    params
  })
}


